const DocumentIcon = ({ width = '24', height = '24' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="solar:document-bold">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.922 4.00403C2.75 5.17503 2.75 7.06103 2.75 10.832V14.832C2.75 18.603 2.75 20.489 3.922 21.66C5.093
          22.832 6.979 22.832 10.75 22.832H12.75C16.521 22.832 18.407 22.832 19.578 21.66C20.75 20.489 20.75 18.603
          20.75 14.832V10.832C20.75 7.06103 20.75 5.17503 19.578 4.00403C18.407 2.83203 16.521 2.83203 12.75
          2.83203H10.75C6.979 2.83203 5.093 2.83203 3.922 4.00403ZM7.75 10.082C7.55109 10.082 7.36032 10.161
          7.21967 10.3017C7.07902 10.4424 7 10.6331 7 10.832C7 11.0309 7.07902 11.2217 7.21967 11.3624C7.36032
          11.503 7.55109 11.582 7.75 11.582H15.75C15.9489 11.582 16.1397 11.503 16.2803 11.3624C16.421 11.2217
          16.5 11.0309 16.5 10.832C16.5 10.6331 16.421 10.4424 16.2803 10.3017C16.1397 10.161 15.9489 10.082
          15.75 10.082H7.75ZM7.75 14.082C7.55109 14.082 7.36032 14.161 7.21967 14.3017C7.07902 14.4424 7 14.6331
          7 14.832C7 15.0309 7.07902 15.2217 7.21967 15.3624C7.36032 15.503 7.55109 15.582 7.75 15.582H12.75C12.9489
          15.582 13.1397 15.503 13.2803 15.3624C13.421 15.2217 13.5 15.0309 13.5 14.832C13.5 14.6331 13.421 14.4424
          13.2803 14.3017C13.1397 14.161 12.9489 14.082 12.75 14.082H7.75Z"
          fill="#003B58"
        />
      </g>
    </svg>
  );
};

export default DocumentIcon;
